module.exports = __webpack_public_path__ + "img/89.2ac7fe50.jpg";